/**
 * This component is not intended to be a header in terms of h1 h2 h3 but rather a component that can be used to display a title or a subtitle of a section.
 */
import React from "react";

interface HeaderProps {
  size: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl";
  hideUnderline?: boolean;
  children: React.ReactNode;
  className?: string;
}

const Header: React.FC<HeaderProps> = ({
  size,
  hideUnderline,
  children,
  className,
}) => {
  /** Lets you use standardized values and not have to worry about responsiveness everytime you make a new header */
  const sizeMap: Record<HeaderProps["size"], string> = {
    sm: "text-sm",
    md: "text-md",
    lg: "text-[20px]",
    xl: "text-[24px]",
    "2xl": "text-[30px]",
    "3xl": "text-[40px]",
  };

  return (
    <div
      className={`font-bebasneue ${sizeMap[size]} font-normal leading-[110%] tracking-[0.25px] ${hideUnderline ? "" : "underline"} ${className}`}
    >
      {children}
    </div>
  );
};

export default Header;
